import * as React from 'react'
import { SVGProps } from 'react'

// Icon "Nav/Library" from "icons" page (Figma)
export const SvgReactComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M6.13896 3.5L3.29999 3.5L3.29999 20.8559L6.13896
            20.8559L6.13896 3.5ZM3.29999 2.5C2.7477 2.5 2.29999
            2.94771 2.29999 3.5V20.8559C2.29999 21.4082 2.7477
            21.8559 3.29999 21.8559H6.13896C6.69124 21.8559
            7.13896 21.4082 7.13896 20.8559V3.5C7.13896 2.94772
            6.69124 2.5 6.13896 2.5H3.29999ZM12.1877 3.5L9.3487
            3.5L9.3487 20.8559L12.1877 20.8559L12.1877 3.5ZM9.3487
            2.5C8.79641 2.5 8.3487 2.94771 8.3487 3.5V20.8559C8.3487
            21.4082 8.79641 21.8559 9.3487 21.8559H12.1877C12.74
            21.8559 13.1877 21.4082 13.1877 20.8559V3.5C13.1877
            2.94772 12.74 2.5 12.1877 2.5H9.3487ZM15.5698 8.37172L18.3566
            7.83002L20.7799 20.2967L17.9931 20.8384L15.5698
            8.37172ZM14.5882 8.56253C14.4828 8.02039 14.8369 7.49548
            15.379 7.3901L18.1658 6.8484C18.708 6.74302 19.2329 7.09708
            19.3383 7.63921L21.7615 20.1059C21.8669 20.648 21.5128 21.1729
            20.9707 21.2783L18.1839 21.82C17.6418 21.9254 17.1168 21.5713
            17.0115 21.0292L14.5882 8.56253Z"/>
    </svg>
);
